import { render, staticRenderFns } from "./modalApproveUjo.vue?vue&type=template&id=294476ee&scoped=true"
import script from "./modalApproveUjo.vue?vue&type=script&lang=js"
export * from "./modalApproveUjo.vue?vue&type=script&lang=js"
import style0 from "./modalApproveUjo.vue?vue&type=style&index=0&id=294476ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294476ee",
  null
  
)

export default component.exports